import React, {useCallback, useEffect, useState} from 'react';

import {Scrollable} from '@pb/kit-component-scrollable';
import {Body, Cell, Head, Table} from '@pb/kit-component-table';

import {scrollableTableHeadCell, scrollableTableShownHeadCell} from './scrollable-table.module.styl';

import type {ReactNode} from 'react';

type HeadCell = {
    cell: React.ReactNode,
    props?: {
        width?: number,
        className?: string,
    },
};

type Props = {
    maxBodyHeight: number,
    head: Array<HeadCell>,
    body: ReactNode,
    border?: boolean,
};

const MAX_BODY_HEIGHT = 480;
const MODAL_BUT_SCROLLABLE_HEIGHT = 300;


const getWindowDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    return {width, height};
};

const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState<{width: number, height: number}>(getWindowDimensions());

    const handleResize = useCallback(() => {
        setWindowDimensions(getWindowDimensions());
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return windowDimensions;
};


export const ScrollableTable: React.FC<Props> = ({head, body, maxBodyHeight = MAX_BODY_HEIGHT, border = false}) => {
    const {height} = useWindowDimensions();

    const [modelMainScrollableSize, setModelMainScrollableSize] = useState<number | undefined>();

    useEffect(() => {
        const newModalMainSize = height - MODAL_BUT_SCROLLABLE_HEIGHT;

        setModelMainScrollableSize(newModalMainSize > maxBodyHeight ? maxBodyHeight : newModalMainSize);
    }, [height, maxBodyHeight]);

    return (
        <>
            <Table borderedGrid={border}>
                <Head>
                    {head.map(({props, cell}, i) => (
                        <Cell key={i} {...props} className={scrollableTableShownHeadCell}>
                            {cell}
                        </Cell>
                    ))}
                </Head>
            </Table>
            <div style={{maxHeight: modelMainScrollableSize}}>
                <Scrollable emitCustomEvent={true} absolute={true}>
                    <Table borderedGrid={border}>
                        <Head>
                            {head.map(({props}, i) => (
                                <Cell key={i} className={scrollableTableHeadCell} {...props}/>
                            ))}
                        </Head>
                        <Body>
                            {body}
                        </Body>
                    </Table>
                </Scrollable>
            </div>
        </>
    );
};
